<script>
	import OtherSkills from './OtherSkills.svelte';
	import Timeline from './Timeline.svelte';

  let heading ={
        "title": "What I Did/Do",
        "subtitle": "Experience"
    }

  let color = {
        "name": "pink",
        "hex": "#f8d7da"
    }

  let details = [
        {
            "institution": "CareerFoundry, Germany - Remote",
            "start": "January 2021",
            "end": "Present",
            "title": "Mentor",
            "stack": "JavaScript, MERN",
            "jobDescription": [
              "Reviewing students’ work through the CareerFoundry platform on a regular basis with a view on how it would fit into an industry-ready portfolio.",
              "Be available for 1-to-1 video calls to help prepare students entry into their new industry.",
              "Suggesting supplemental learning materials and personal insights in areas where students are struggling.",
              "Teaming up with a tutor to answer more advanced queries or for a higher level of troubleshooting.",
            ]
        },
        {
          "institution": "Center for Performance, Monitoring and Evaluative Research (CPMER), Uganda",
          "start": "January 2020",
          "end": "August 2020",
          "title": "Technical Lead",
          "stack": "Backend: Laravel | NodeJS, Frontend: React",
          "jobDescription":[
            "Lead a team that designed and developed a monitoring, learning, evaluation and reporting information management system (MERLS) for the ministry of Energy, Uganda"
          ]
        },
        {
          "institution": "Alliance Forum for Development (AFOD), Uganda",
          "start": "November 2017",
          "end": "October 2021",
          "title": "Software Development Consultant",
          "stack": "Backend: Laravel | Rails, Frontend: React",
          "jobDescription":[
            "Work with the Monitoring and Evaluations Manager to conceptualize a design for a programs database to facilitate information aggregation across the organization’s thematic areas."
          ]
        }

  ]

  //   sort details by start recent to oldest
  details.sort((a, b) => {
    return new Date(b.start) - new Date(a.start);
  });
</script>

<Timeline {color} timelineHeading={heading} isEducation={false} timelineDetails={details} />